import React from 'react';
import { Tooltip as TooltipMUI } from '@material-ui/core';
import useStyles from './Tooltip.styles';

type PlacementProps =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

export interface TooltipProps {
  title: string | React.ReactElement;
  children: React.ReactElement<any, any>;
  arrow: boolean;
  dataQaId: string;
  placement?: PlacementProps;
  interactive?: boolean;
  enterDelay?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
  title,
  children,
  arrow,
  dataQaId,
  placement = 'top',
  interactive,
  enterDelay,
}) => {
  const classes = useStyles();
  return (
    <TooltipMUI
      data-qa-id={`${dataQaId}-tooltip-anchor`}
      id={`${dataQaId}-popper-component`}
      title={title}
      arrow={arrow}
      placement={placement}
      classes={classes}
      interactive={interactive}
      enterDelay={enterDelay}
    >
      {children}
    </TooltipMUI>
  );
};

export default Tooltip;
